import { useState } from "react";
import { genreOptions, regionOptions, yearOptions, sortOptions } from "@/mocks/catalog";

interface FilterBarProps {
  type: string;
  genre: string;
  region: string;
  year: string;
  sort: string;
  onChange: (patch: { genre?: string; region?: string; year?: string; sort?: string }) => void;
}

interface RowProps {
  label: string;
  options: { key: string; label: string }[];
  value: string;
  onSelect: (key: string) => void;
}

function FilterRow({ label, options, value, onSelect }: RowProps) {
  return (
    <div className="flex items-start gap-3 py-2.5">
      <span className="w-14 flex-shrink-0 pt-1 text-sm font-medium text-foreground-500">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onSelect(opt.key)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1 text-sm transition-colors ${
              value === opt.key
                ? "bg-accent-500 text-white"
                : "bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-700"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({ type, genre, region, year, sort, onChange }: FilterBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const genres = genreOptions[type] || genreOptions.movie;
  const genreItems = genres.map((g) => ({ key: g, label: g }));
  const regionItems = regionOptions.map((r) => ({ key: r, label: r }));
  const yearItems = yearOptions.map((y) => ({ key: y, label: y }));
  const sortItems = sortOptions.map((s) => ({ key: s.key, label: s.label }));

  const activeCount =
    (genre !== "全部" ? 1 : 0) + (region !== "全部" ? 1 : 0) + (year !== "全部" ? 1 : 0);

  const content = (
    <div className="divide-y divide-background-200">
      <FilterRow label="类型" options={genreItems} value={genre} onSelect={(v) => onChange({ genre: v })} />
      <FilterRow label="地区" options={regionItems} value={region} onSelect={(v) => onChange({ region: v })} />
      <FilterRow label="年份" options={yearItems} value={year} onSelect={(v) => onChange({ year: v })} />
      <FilterRow label="排序" options={sortItems} value={sort} onSelect={(v) => onChange({ sort: v })} />
    </div>
  );

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-2">
      <button
        type="button"
        onClick={() => setMobileOpen((v) => !v)}
        className="flex w-full cursor-pointer items-center justify-between py-2 text-sm font-medium text-foreground-800 md:hidden"
      >
        <span className="inline-flex items-center gap-2">
          <i className="ri-filter-3-line text-lg text-accent-600" aria-hidden="true" />
          筛选条件
          {activeCount > 0 ? (
            <span className="rounded-md bg-accent-100 px-1.5 py-0.5 text-xs text-accent-700">
              已选 {activeCount}
            </span>
          ) : null}
        </span>
        <i
          className={mobileOpen ? "ri-arrow-up-s-line text-lg" : "ri-arrow-down-s-line text-lg"}
          aria-hidden="true"
        />
      </button>

      <div className={`${mobileOpen ? "block pb-3" : "hidden"} md:block md:pb-0`}>{content}</div>
    </div>
  );
}